require('./bootstrap');

require('./components/dashboard/dashboard.jsx');
require('./components/dashboard/info-dashboard.jsx');

require('./components/jobs/add-new-job.jsx');
require('./components/jobs/customer-job-bulk-upload.jsx');
require('./components/jobs/quick-new-job.jsx');

require('./components/jobs/all-jobs.jsx');
require('./components/jobs/jobs-in-progress.jsx');
require('./components/jobs/jobs-first-look-page.jsx');
require('./components/jobs/add-new-job-with-jobid.jsx');
require('./components/jobs/subcontracted-jobs.jsx');
require('./components/jobs/planned-jobs.jsx');
require('./components/jobs/unplanned-jobs.jsx');
require('./components/jobs/sent-jobs.jsx');
require('./components/jobs/unsent-jobs.jsx');
require('./components/jobs/completed-jobs.jsx');
require('./components/jobs/split-jobs.jsx');
require('./components/jobs/parent-jobs.jsx');
require('./components/jobs/aborted-jobs.jsx');
require('./components/jobs/cancelled-jobs.jsx');
require('./components/jobs/deleted-jobs.jsx');
require('./components/jobs/job.jsx');
require('./components/jobs/jobs-table.jsx');


require('./components/jobs/job-full-details/' +
  'job-full-details-main-details.jsx'
);
require('./components/jobs/job-full-details/' +
  'job-full-details-invoice.jsx'
);
require('./components/jobs/job-full-details/' +
  'job-full-details-job-notifications.jsx'
);
require('./components/jobs/job-full-details/' +
  'job-full-details-driver-messages.jsx'
);
require('./components/jobs/job-full-details/' +
  'job-full-details-driver-documents.jsx'
);
require('./components/jobs/jobs-table-column-toggler.jsx');
require('./components/jobs/job-full-details/' +
  'job-full-details-tools.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-download-appraisals-and-receipts-for-job.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-job-splitter.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-job-subcontractor.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-abort-unabort.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-cancel-uncancel.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-remove-driver-from-job.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-delete-undelete.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-job-recall.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-mark-unmark-job-as-has-an-issue.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-mark-unmark-job-as-has-a-major-issue.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-mark-unmark-job-as-checked.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-mark-unmark-job-as-prechecked.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-mark-unmark-job-as-vehicle-on-site.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-mark-unmark-job-as-needs-planning-asap.jsx'
);
require('./components/jobs/job-full-details/tools/buttons/' +
  'job-full-details-tools-buttons-mark-unmark-job-as-does-not-require-planning-yet.jsx'
);

require('./components/jobs/view-job.jsx');
require('./components/jobs/view-jobs-for-customer.jsx');
require('./components/jobs/view-invoiced-jobs-for-customer.jsx');
require('./components/jobs/view-jobs-for-company.jsx');
require('./components/jobs/view-jobs-for-driver.jsx');

require('./components/jobs/expense-approval.jsx');
require('./components/jobs/awaiting-invoice.jsx');
require('./components/jobs/invoiced.jsx');


require('./components/companies/companies.jsx');

require('./components/customers/all-customers.jsx');
require('./components/customers/all-users.jsx');
require('./components/customers/customer-pricing-history.jsx');
require('./components/customers/all-pending-customers.jsx');
require('./components/customers/customer.jsx');
require('./components/customers/view-customer.jsx');
require('./components/customers/add-new-customer.jsx');
require('./components/customers/customer-full-details.jsx');

require('./components/customers/customers-table.jsx');


require('./components/drivers/add-new-driver.jsx');
require('./components/drivers/add-new-haulier-driver.jsx');
require('./components/subcontractors/add-new-subcontractor.jsx');
require('./components/drivers/view-driver.jsx');
require('./components/drivers/view-driver/all-jobs.jsx');
require('./components/customers/view-customer/all-jobs.jsx');
require('./components/customers/all-archived-customers.jsx');
require('./components/drivers/driver.jsx');
require('./components/drivers/dashboard/dashboard.jsx');
require('./components/drivers/schedules/schedules.jsx');
require('./components/drivers/expenses/expense-accounts.jsx');
require('./components/drivers/excesses/drivers-excesses.jsx');
require('./components/drivers/fines/drivers-fines.jsx');
require('./components/drivers/uniforms/drivers-uniforms.jsx');
require('./components/drivers/tablets/drivers-tablets.jsx');
require('./components/drivers/dashcamrentals/drivers-dashcamrentals.jsx');

require('./components/drivers/tradeplates/drivers-tradeplates.jsx');
require('./components/drivers/additionstowages/drivers-additionstowages.jsx');
require('./components/drivers/additional-damages/drivers-additional-damages.jsx');
require('./components/drivers/wages/wage-accounts.jsx');


require('./components/sidebars/drivers-priority-list.jsx');
require('./components/sidebars/notifications-list.jsx');


require('./components/portal-admin/all-portal-users.jsx');
require('./components/portal-admin/all-portal-users-task-list.jsx');
require('./components/portal-admin/view-user.jsx');
require('./components/portal-admin/portal-drivers.jsx');
require('./components/portal-admin/portal-haulier-drivers.jsx');
require('./components/portal-admin/portal-subcontractors.jsx');
require('./components/portal-admin/portal-archived-drivers.jsx');
require('./components/portal-admin/portal-company-admins.jsx');
require('./components/portal-admin/portal-financials.jsx');
require('./components/portal-admin/portal-job-planners.jsx');
require('./components/portal-admin/portal-admins.jsx');
require('./components/portal-admin/portal-super-admins.jsx');
require('./components/portal-admin/add-new-portal-account.jsx');
require('./components/portal-admin/portal-daily-delivered-log.jsx');
require('./components/portal-admin/memo-history.jsx');

require('./components/portal-admin/system-support/system-support.jsx');
require('./components/portal-admin/system-settings/system-settings.jsx');

require('./components/search/portal-search.jsx');
require('./components/job-scheduling/portal-job-scheduler.jsx');
require('./components/drivers/calendar/calendar.jsx');
require('./components/job-splitting/portal-job-splitter.jsx');
require('./components/job-splitting/portal-job-splitter.jsx');

require('./components/planning/group-work.jsx');
require('./components/planning/planner_report.jsx');
require('./components/planning/otm_report.jsx');

require('./components/finance/monthly-vat-report.jsx');
require('./components/finance/vat-report-sccd.jsx');
require('./components/finance/daily-account-expense-report.jsx');
require('./components/finance/aborted_jobs_report.jsx');
require('./components/finance/monthly_confirmed_jobs_aborted_jobs_report.jsx');
require('./components/finance/invoiced_jobs_report.jsx');
require('./components/finance/non_invoiced_jobs_report.jsx');
require('./components/finance/customer_approved_expense_report.jsx');
require('./components/finance/customer_all_jobs_report.jsx');
require('./components/finance/timings_report.jsx');
require('./components/finance/unplanned_report.jsx');
require('./components/finance/expense_not_approved_report.jsx');
require('./components/finance/driver_paid_expense_report.jsx');
require('./components/finance/driver_all_job_report.jsx');
require('./components/finance/monthly_called_jobs_report.jsx');
require('./components/finance/total_jobs_raised_by_user_report.jsx');
require('./components/finance/jobs_details_report.jsx');
require('./components/finance/total_jobs_raised_by_subcontractor_report.jsx');
require('./components/finance/weekly_driver_wages_report.jsx');
require('./components/finance/driver_damages_report.jsx');
require('./components/finance/subcontracted_jobs_report.jsx');
require('./components/finance/outsourced-jobs-report.jsx');
require('./components/finance/subcontractor_invoices_report.jsx');
require('./components/finance/customer_jobs_report.jsx');
require('./components/finance/profit_report.jsx');
require('./components/finance/total_jobs_set_to_invoice_report.jsx');

require('./components/portal-admin/add-new-user.jsx');
require('./components/drivers/priority-list.jsx');
require('./components/customers/import-customer-jobs.jsx');

import 'react-power-select/dist/react-power-select.css'


// jQuery below. [TODO] eventually refactor out all jQuery.

$(document).on(
  'click',
  '#notifications-list-panel-left-hide-show-toggle .hide',
  function () {
    $('#notifications-list-panel-left').addClass('hidden');
    $('#notifications-list-panel-left-hide-show-toggle').addClass('hidden');
    $('.container').addClass('left-hidden');

    $.ajax({
      url: "/api/v1/portal/sidebars/notifications-list/hide",
      data: { api_token: window.api_token },
      cache: false
    });
  });

$(document).on(
  'click',
  '#notifications-list-panel-left-hide-show-toggle .show',
  function () {
    $('#notifications-list-panel-left').removeClass('hidden');
    $('#notifications-list-panel-left-hide-show-toggle').removeClass('hidden');
    $('.container').removeClass('left-hidden');

    $.ajax({
      url: "/api/v1/portal/sidebars/notifications-list/show",
      data: { api_token: window.api_token },
      cache: false
    });
  });

$(document).on(
  'click',
  '#drivers-priority-list-panel-right-hide-show-toggle .hide',
  function () {
    $('#drivers-priority-list-panel-right').addClass('hidden');
    $('#drivers-priority-list-panel-right-hide-show-toggle').addClass('hidden');
    $('.container').addClass('right-hidden');

    $.ajax({
      url: "/api/v1/portal/sidebars/drivers-priority-list/hide",
      data: { api_token: window.api_token },
      cache: false
    });
  });

$(document).on(
  'click',
  '#drivers-priority-list-panel-right-hide-show-toggle .show',
  function () {
    $('#drivers-priority-list-panel-right').removeClass('hidden');
    $('#drivers-priority-list-panel-right-hide-show-toggle').removeClass('hidden');
    $('.container').removeClass('right-hidden');

    $.ajax({
      url: "/api/v1/portal/sidebars/drivers-priority-list/show",
      data: { api_token: window.api_token },
      cache: false
    });
  });

$(document).on('click', '.pop', function (e) {
  e.preventDefault();
  $('.imagepreview').attr('src', $(this).find('img').attr('src'));
  $('#imagemodal').modal('show');
});
$('#navbarCurrentUserDropdown').click(function (e) {
  e.preventDefault();
  if ($('ul.current-user-nav-element li.nav-item').hasClass('show')) {
    $('form.columns-toggle .btn-default').removeClass('disable-pointer-events');
  } else {
    $('form.columns-toggle .btn-default').addClass('disable-pointer-events');
  }
});
$('li a.total_customer_jobs').mouseover((e) => {
  $('.loggedin-customer-notification').show();
});
$('li a.total_customer_jobs').mouseout((e) => {
  $('.loggedin-customer-notification').hide();
});
$(document).ready(function () {
  $('[data-toggle="tooltip"]').tooltip();
});